import { BACKOFFICE_ROLE_HEADER } from '../../constantsConfig/constantsConfig';
import type {
  EntraLoginRequest,
  EntraLoginResponse,
  IEntraIdAuthService,
} from '../../types/serviceType';
import { ENTRA_ID_ROUTES } from '../requestsService';

export class EntraIdAuthService implements IEntraIdAuthService {
  private fetch: <T = unknown>(endpoint: string, options?: RequestInit) => Promise<T>;

  constructor(fetch: <T = unknown>(endpoint: string, options?: RequestInit) => Promise<T>) {
    this.fetch = fetch;
  }

  /**
   * Login backoffice via Microsoft Entra ID (OIDC/PKCE).
   * Role header is always BACKOFFICE for this call.
   * The 200 body is still under construction — callers should not depend on user data yet.
   */
  async postEntraLogin(request: EntraLoginRequest): Promise<EntraLoginResponse> {
    const code = request?.code?.trim();
    const codeVerifier = request?.codeVerifier?.trim();
    const nonce = request?.nonce?.trim();

    if (!code || !codeVerifier || !nonce) {
      throw new Error('Code, codeVerifier e nonce são obrigatórios');
    }

    return this.fetch<EntraLoginResponse>(ENTRA_ID_ROUTES.POST_ENTRA_LOGIN, {
      method: 'POST',
      headers: {
        Role: BACKOFFICE_ROLE_HEADER,
      },
      body: JSON.stringify({ code, codeVerifier, nonce }),
    });
  }
}
